export default {
  "@global": {
    "@font-face": [
      {
        fontFamily: "museo-sans"
      }
    ]
  }
};
